import { render } from "./OurExploration.vue?vue&type=template&id=422b9b16&scoped=true"
import script from "./OurExploration.vue?vue&type=script&lang=js"
export * from "./OurExploration.vue?vue&type=script&lang=js"

import "./OurExploration.vue?vue&type=style&index=0&id=422b9b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422b9b16"]])

export default __exports__